exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".CircledIcon-72be510c{border:3px solid #C8E6DC;border-radius:50%;display:flex;justify-content:center;align-items:center;margin-right:10px}.CircledIcon-72be510c span{color:#757575}\n", ""]);

// Exports
exports.locals = {
	"CircledIcon": "CircledIcon-72be510c"
};